import gql from 'graphql-tag'

export const getFileViewUrl = gql`
  query($fileId: Int!) {
    getFileViewUrl(
      fileId: $fileId
    )
  }
`

export const getSTSCredentials = gql`
  query {
    getSTSCredentials {
      accessKeyId
      secretAccessKey
      sessionToken
      expiration
      bucket
      region
    }
  }
`

// """AWS Textract 临时授权"""
export const getTextractTempCredentials = gql`
  query {
    getTextractTempCredentials {
      accessKeyId
      secretAccessKey
      sessionToken
      expiration
      bucket
      region
    }
  }
`

export const uploadFile = gql`
  mutation($masterType: HistoryMasterType!, $masterId: Int!, $fileInput: NewFileInput!) {
    uploadFile(
      masterId: $masterId,
      masterType: $masterType,
      fileInput: $fileInput
    )
  }
`

export const uploadFiles = gql`
  mutation($masterType: HistoryMasterType!, $masterId: Int!, $filesInput: [NewFileInput!]!) {
    uploadFiles(
      masterId: $masterId,
      masterType: $masterType,
      filesInput: $filesInput
    )
  }
`

export const renameFile = gql`
  mutation($fileId: Int!, $fileName: String!) {
    renameFile(
      fileId: $fileId,
      fileName: $fileName,
    ) {
      id
      name
    }
  }
`

export const deleteFile = gql`
  mutation($fileId: Int!) {
    deleteFile(
      fileId: $fileId,
    )
  }
`
